import { DefaultAvatarContainerStyle } from './style.css';

/**
 * Monochrome fallback avatar: a neutral square with the first letter.
 * Kept the same export name and props so every `colorfulFallback`
 * call site picks the new look up automatically.
 */
export const ColorfulFallback = ({ char }: { char: string }) => {
  return (
    <div
      className={DefaultAvatarContainerStyle}
      style={{
        backgroundColor: 'var(--affine-v2-layer-background-tertiary)',
        color: 'var(--affine-v2-text-primary)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        lineHeight: 1,
      }}
    >
      <span style={{ fontSize: '50%' }}>{char.slice(0, 1).toUpperCase()}</span>
    </div>
  );
};
export default ColorfulFallback;
